import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"width":"90vw"} }
const _hoisted_2 = { class: "d-flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Edition = _resolveComponent("Edition")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog) = $event)),
    actions: _ctx.actions
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.dialog)
          ? (_openBlock(), _createBlock(_component_Edition, {
              key: 0,
              companyId: _ctx.companyId,
              actions: _ctx.actions,
              onUpsert: _ctx.refresh
            }, null, 8, ["companyId", "actions", "onUpsert"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_switch, {
            modelValue: _ctx.keepFormOpen,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keepFormOpen) = $event)),
            label: "Saisie au KM"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "actions"]))
}